import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
interface IconProps {
  color?: string;
}

const AgreementSVG = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.4444 0V1.77778H15.1173C15.6044 1.77778 16 2.17333 16 2.66044V16.8951C16 17.3822 15.6044 17.7778 15.1173 17.7778H0.882667C0.395556 17.7778 0 17.3822 0 16.8951V2.66044C0 2.17333 0.395556 1.77778 0.882667 1.77778H3.55556V0H12.4444ZM3.55556 3.55556H1.77778V16H14.2222V3.55556H12.4444V5.33333H3.55556V3.55556ZM5.33333 12.4444V14.2222H3.55556V12.4444H5.33333ZM5.33333 9.77778V11.5556H3.55556V9.77778H5.33333ZM5.33333 7.11111V8.88889H3.55556V7.11111H5.33333ZM10.6667 1.77778H5.33333V3.55556H10.6667V1.77778Z" />
  </svg>
);
const LinkSVG = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2272_18907)">
      <path d="M12 20.1C10.29 20.1 8.9 18.71 8.9 17L8.9 13L7 13L7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17L17 13L15.1 13L15.1 17C15.1 18.71 13.71 20.1 12 20.1ZM13 16L13 8L11 8L11 16L13 16ZM7 7L7 11L8.9 11L8.9 7C8.9 5.29 10.29 3.9 12 3.9C13.71 3.9 15.1 5.29 15.1 7L15.1 11L17 11L17 7C17 4.24 14.76 2 12 2C9.24 2 7 4.24 7 7Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_2272_18907">
        <rect width={24} height={24} fill="white" transform="translate(0 24) rotate(-90)" />
      </clipPath>
    </defs>
  </svg>
);

const OrdersSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M13.4707 0C13.9081 0 14.2631 0.354992 14.2631 0.792393V3.76941L12.6783 5.3542V1.58479H1.58479V14.2631H12.6783V12.0777L14.2631 10.4929V15.0555C14.2631 15.4929 13.9081 15.8479 13.4707 15.8479H0.792393C0.354992 15.8479 0 15.4929 0 15.0555V0.792393C0 0.354992 0.354992 0 0.792393 0H13.4707ZM14.8796 5.39461L16 6.51506L9.83677 12.6783L8.71474 12.6767L8.71632 11.5578L14.8796 5.39461V5.39461ZM7.92393 7.92393V9.50872H3.96197V7.92393H7.92393ZM10.3011 4.75436V6.33914H3.96197V4.75436H10.3011Z"
    />
  </svg>
);

const DashboardSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M7.77778 14V6.22222H14V14H7.77778ZM0 7.77778V0H6.22222V7.77778H0ZM4.66667 6.22222V1.55556H1.55556V6.22222H4.66667ZM0 14V9.33333H6.22222V14H0ZM1.55556 12.4444H4.66667V10.8889H1.55556V12.4444ZM9.33333 12.4444H12.4444V7.77778H9.33333V12.4444ZM7.77778 0H14V4.66667H7.77778V0ZM9.33333 1.55556V3.11111H12.4444V1.55556H9.33333Z"
    />
  </svg>
);

const StatusSVG = () => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9999 1L11.5405 5.45946L9.51343 3.43243"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.67568 3.43262H1"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9999 8.70264L11.5405 13.1621L9.51343 11.1351"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.67568 11.1353H1"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DropboxSVG = () => (
  <svg
    width={28}
    height={25}
    viewBox="0 0 28 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.534 18.622L13.776 14.492L11.769 19.245L4.249 15.955L4.424 19.861L13.861 24.235L24.771 18.87L24.621 13.88L15.534 18.622ZM27.91 3.238L16.976 0L13.971 2.67L10.881 0.312L0 4.818L3.796 7.865L0.366 13.168L11.246 17.924L13.776 11.926L16.032 17.234L27.425 11.292L24.32 6.582L27.912 3.237L27.91 3.238ZM13.733 11.198L4.673 7.368L13.949 3.266L23.556 6.521L13.733 11.198Z"
      fill="#EB5757"
    />
  </svg>

);

const ProfessionalSVG = () => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M11.9091 13.2725V11.9089C11.9091 11.1856 11.6218 10.4919 11.1103 9.98044C10.5988 9.46898 9.90514 9.18164 9.18182 9.18164H3.72727C3.00396 9.18164 2.31026 9.46898 1.7988 9.98044C1.28734 10.4919 1 11.1856 1 11.9089V13.2725"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.45457 6.45455C7.9608 6.45455 9.18184 5.2335 9.18184 3.72727C9.18184 2.22104 7.9608 1 6.45457 1C4.94834 1 3.72729 2.22104 3.72729 3.72727C3.72729 5.2335 4.94834 6.45455 6.45457 6.45455Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13.2728V11.9091C15.9996 11.3049 15.7985 10.7179 15.4282 10.2403C15.058 9.76268 14.5397 9.42158 13.9546 9.27051"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2273 1.08887C11.8139 1.23907 12.3339 1.58025 12.7052 2.05862C13.0765 2.53699 13.2781 3.12534 13.2781 3.73091C13.2781 4.33648 13.0765 4.92483 12.7052 5.4032C12.3339 5.88157 11.8139 6.22275 11.2273 6.37296"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const EditIconSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path d="M18.311 2.828l2.861 2.861-15.033 15.032-2.859-2.862 15.031-15.031zm0-2.828l-16.873 16.872-1.438 7.127 7.127-1.437 16.873-16.873-5.689-5.689z" />
  </svg>
);

const SearchIconSVG = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_220_4610)">
      <path
        d="M15.7125 14.8637L11.8882 11.0171C12.8362 9.85469 13.4075 8.36571 13.4075 6.74286C13.4075 3.02041 10.4046 0 6.70377 0C2.99965 0 0 3.02041 0 6.74286C0 10.4653 2.99965 13.4857 6.70377 13.4857C8.31722 13.4857 9.79432 12.9143 10.95 11.9608L14.7743 15.8041C15.034 16.0653 15.4528 16.0653 15.7125 15.8041C15.9722 15.5461 15.9722 15.1216 15.7125 14.8637ZM6.70377 12.1437C3.73983 12.1437 1.33101 9.72082 1.33101 6.74286C1.33101 3.7649 3.73983 1.33878 6.70377 1.33878C9.66446 1.33878 12.0765 3.7649 12.0765 6.74286C12.0765 9.72082 9.66446 12.1437 6.70377 12.1437Z"
        fill="#AAAAAA"
      />
    </g>
    <defs>
      <clipPath id="clip0_220_4610">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ArrowDownIconSVG = () => (
  <svg
    width={10}
    height={6}
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.71655 0.232035C8.85799 0.0833867 9.04899 0 9.24803 0C9.44708 0 9.63807 0.0833867 9.77951 0.232035C9.84935 0.305029 9.9048 0.392037 9.94265 0.487995C9.98051 0.583952 10 0.686942 10 0.790971C10 0.895001 9.98051 0.99799 9.94265 1.09395C9.9048 1.18991 9.84935 1.27691 9.77951 1.34991L5.53202 5.76833C5.39026 5.91677 5.19913 6 5 6C4.80087 6 4.60974 5.91677 4.46798 5.76833L0.220486 1.34991C0.150654 1.27691 0.0951987 1.18991 0.057346 1.09395C0.0194934 0.99799 0 0.895001 0 0.790971C0 0.686942 0.0194934 0.583952 0.057346 0.487995C0.0951987 0.392037 0.150654 0.305029 0.220486 0.232035C0.361925 0.0833867 0.552923 0 0.751966 0C0.951008 0 1.14201 0.0833867 1.28345 0.232035L5.00163 3.8556L8.71655 0.232035Z"
      fill="#333333"
    />
  </svg>
);

const ArrowRightIconSVG = () => (
  <svg
    width={6}
    height={10}
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.232035 1.28345C0.0833863 1.14201 -3.95544e-07 0.951008 -4.04244e-07 0.751966C-4.12945e-07 0.552923 0.0833862 0.361925 0.232035 0.220486C0.305029 0.150655 0.392037 0.0951986 0.487994 0.0573454C0.583952 0.0194931 0.686942 -3.00272e-08 0.790971 -3.45745e-08C0.895 -3.91217e-08 0.99799 0.0194931 1.09395 0.0573453C1.1899 0.0951986 1.27691 0.150655 1.34991 0.220486L5.76833 4.46798C5.91677 4.60974 6 4.80086 6 5C6 5.19913 5.91677 5.39026 5.76833 5.53202L1.34991 9.77951C1.27691 9.84935 1.18991 9.9048 1.09395 9.94265C0.99799 9.98051 0.895001 10 0.790971 10C0.686942 10 0.583952 9.98051 0.487995 9.94265C0.392037 9.9048 0.305029 9.84935 0.232035 9.77951C0.0833866 9.63808 -2.41691e-08 9.44708 -3.28695e-08 9.24803C-4.15699e-08 9.04899 0.0833866 8.85799 0.232035 8.71655L3.8556 4.99837L0.232035 1.28345Z"
      fill="#333333"
    />
  </svg>

);

const ArrowLeftIconSVG = () => (
  <svg
    width={6}
    height={10}
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.76797 8.71655C5.91661 8.85799 6 9.04899 6 9.24803C6 9.44708 5.91661 9.63807 5.76797 9.77951C5.69497 9.84935 5.60796 9.9048 5.51201 9.94265C5.41605 9.98051 5.31306 10 5.20903 10C5.105 10 5.00201 9.98051 4.90605 9.94265C4.81009 9.9048 4.72309 9.84935 4.65009 9.77951L0.231669 5.53202C0.0832263 5.39026 6.19991e-08 5.19913 5.96244e-08 5C5.72497e-08 4.80087 0.0832263 4.60974 0.231669 4.46798L4.65009 0.220486C4.72309 0.150654 4.81009 0.0951987 4.90605 0.057346C5.00201 0.0194934 5.105 1.06728e-08 5.20903 9.43224e-09C5.31306 8.1917e-09 5.41605 0.0194934 5.51201 0.057346C5.60796 0.0951987 5.69497 0.150654 5.76796 0.220486C5.91661 0.361925 6 0.552923 6 0.751966C6 0.951008 5.91661 1.14201 5.76797 1.28345L2.1444 5.00163L5.76797 8.71655Z"
      fill="#333333"
    />
  </svg>
);


const CloseIconSVG = ({ fill = 'white' }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.997 20C8.68367 20.0024 7.38281 19.7453 6.16916 19.2434C4.95552 18.7415 3.85303 18.0047 2.92504 17.0754C-0.975015 13.1754 -0.975015 6.83018 2.92504 2.93021C3.85165 1.99842 4.95388 1.25967 6.16792 0.756703C7.38196 0.253738 8.6837 -0.00344705 9.9978 3.48878e-05C12.6696 3.48878e-05 15.1813 1.04024 17.0698 2.93021C18.959 4.81939 20 7.33108 20 10.0028C20 12.6745 18.9598 15.1862 17.0698 17.0754C16.1416 18.0047 15.039 18.7415 13.8252 19.2434C12.6114 19.7453 11.3104 20.0024 9.997 20ZM9.9978 1.60035C8.8939 1.59722 7.80035 1.81315 6.7805 2.23564C5.76065 2.65813 4.83477 3.27878 4.05649 4.06164C2.46974 5.64835 1.59595 7.75837 1.59595 10.0028C1.59595 12.2473 2.46974 14.3565 4.05649 15.944C7.33241 19.2198 12.6632 19.2206 15.9383 15.944C17.5251 14.3573 18.3996 12.2473 18.3996 10.0028C18.3996 7.75837 17.5259 5.64915 15.9383 4.06164C15.16 3.27902 14.2342 2.65852 13.2146 2.23604C12.1949 1.81356 11.1015 1.5975 9.9978 1.60035Z"
      fill={fill}
    />
    <path
      d="M6.87068 14.5454C6.7105 14.5457 6.55382 14.4985 6.42053 14.4096C6.28725 14.3208 6.18336 14.1943 6.12207 14.0463C6.06077 13.8983 6.04483 13.7354 6.07626 13.5783C6.10769 13.4212 6.18508 13.277 6.29861 13.164L13.1643 6.29753C13.2394 6.2224 13.3286 6.1628 13.4268 6.12214C13.5249 6.08148 13.6301 6.06055 13.7364 6.06055C13.8426 6.06055 13.9478 6.08148 14.046 6.12214C14.1441 6.1628 14.2333 6.2224 14.3084 6.29753C14.3836 6.37267 14.4432 6.46187 14.4838 6.56003C14.5245 6.6582 14.5454 6.76342 14.5454 6.86967C14.5454 6.97593 14.5245 7.08114 14.4838 7.17931C14.4432 7.27748 14.3836 7.36668 14.3084 7.44181L7.44275 14.3083C7.36782 14.3837 7.27867 14.4435 7.18047 14.4842C7.08227 14.5249 6.97698 14.5457 6.87068 14.5454Z"
      fill={fill}
    />
    <path
      d="M13.7353 14.5454C13.629 14.5455 13.5237 14.5246 13.4256 14.4839C13.3274 14.4432 13.2382 14.3835 13.1632 14.3083L6.29751 7.44181C6.22238 7.36668 6.16279 7.27748 6.12213 7.17931C6.08147 7.08114 6.06055 6.97593 6.06055 6.86967C6.06055 6.76342 6.08147 6.6582 6.12213 6.56003C6.16279 6.46187 6.22238 6.37267 6.29751 6.29753C6.37263 6.2224 6.46182 6.1628 6.55998 6.12214C6.65813 6.08148 6.76334 6.06055 6.86958 6.06055C6.97582 6.06055 7.08103 6.08148 7.17918 6.12214C7.27734 6.1628 7.36653 6.2224 7.44165 6.29753L14.3073 13.164C14.4209 13.277 14.4982 13.4212 14.5297 13.5783C14.5611 13.7354 14.5452 13.8983 14.4839 14.0463C14.4226 14.1943 14.3187 14.3208 14.1854 14.4096C14.0521 14.4985 13.8954 14.5457 13.7353 14.5454Z"
      fill={fill}
    />
  </svg>
);

const SaveIconSVG = () => (
  <svg
    width={13}
    height={18}
    viewBox="0 0 13 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.64314 0.75H9.64286L3.35714 0.75L3.35686 0.75C1.91355 0.751625 0.751584 1.94122 0.75 3.39972V3.4L0.75 16.6L0.75 16.6003C0.750155 16.7127 0.779134 16.8233 0.834306 16.9213L0.834319 16.9213C1.00989 17.233 1.40439 17.3443 1.71533 17.1627L1.71575 17.1625L6.5 14.357L11.2842 17.1625L11.2856 17.1633C11.3831 17.2197 11.4936 17.2497 11.6064 17.25L11.6076 17.25C11.9663 17.2493 12.2494 16.9546 12.25 16.6004V16.6V3.4V3.39972C12.2484 1.94122 11.0865 0.751625 9.64314 0.75ZM10.9643 15.4714L6.82289 13.0429L6.82153 13.0421C6.72403 12.9858 6.6135 12.9558 6.50071 12.9554L6.49929 12.9554C6.38649 12.9558 6.27597 12.9858 6.17847 13.0421L6.17711 13.0429L2.03571 15.4714V3.40013C2.03675 2.65064 2.63203 2.05103 3.35729 2.05H9.64271C10.368 2.05103 10.9633 2.65074 10.9643 3.40031V15.4714Z"
      fill="white"
      stroke="#262889"
      strokeWidth="0.5"
    />
  </svg>

);

const DeleteIconSVG = () => (
  <svg
    width={13}
    height={16}
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0969 5.71516L11.8239 13.5151C11.8006 14.1831 11.5025 14.8163 10.9927 15.2802C10.4829 15.7442 9.80167 16.0024 9.09351 16H3.9058C3.1981 16.0024 2.51724 15.7445 2.00754 15.2812C1.49784 14.8178 1.19938 14.1853 1.17543 13.5177L0.902389 5.71516C0.896415 5.54429 0.962601 5.37818 1.08639 5.25338C1.21018 5.12857 1.38142 5.05528 1.56246 5.04965C1.74349 5.04401 1.91949 5.10648 2.05172 5.22331C2.18396 5.34014 2.2616 5.50177 2.26758 5.67264L2.54061 13.4745C2.55421 13.8076 2.70402 14.1227 2.95859 14.3537C3.21315 14.5847 3.55266 14.7137 3.9058 14.7134H9.09351C9.44711 14.7136 9.78701 14.5844 10.0416 14.3528C10.2963 14.1212 10.4458 13.8055 10.4587 13.4719L10.7317 5.67264C10.7377 5.50177 10.8154 5.34014 10.9476 5.22331C11.0798 5.10648 11.2558 5.04401 11.4369 5.04965C11.6179 5.05528 11.7891 5.12857 11.9129 5.25338C12.0367 5.37818 12.1029 5.54429 12.0969 5.71516ZM13 3.11947C13 3.29034 12.9281 3.4542 12.8001 3.57502C12.6721 3.69585 12.4984 3.76372 12.3174 3.76372H0.682594C0.501559 3.76372 0.327938 3.69585 0.199927 3.57502C0.0719157 3.4542 0 3.29034 0 3.11947C0 2.9486 0.0719157 2.78474 0.199927 2.66392C0.327938 2.5431 0.501559 2.47522 0.682594 2.47522H2.79863C3.01491 2.47577 3.22367 2.40035 3.38429 2.26364C3.5449 2.12694 3.64588 1.93872 3.66758 1.73562C3.71795 1.25919 3.95444 0.817517 4.33099 0.496664C4.70753 0.175812 5.19714 -0.00123909 5.70444 6.52812e-06H7.29488C7.80217 -0.00123909 8.29179 0.175812 8.66833 0.496664C9.04487 0.817517 9.28137 1.25919 9.33174 1.73562C9.35343 1.93872 9.45442 2.12694 9.61503 2.26364C9.77564 2.40035 9.9844 2.47577 10.2007 2.47522H12.3167C12.4978 2.47522 12.6714 2.5431 12.7994 2.66392C12.9274 2.78474 13 2.9486 13 3.11947ZM4.85256 2.47522H8.14812C8.05843 2.28178 7.99976 2.0768 7.97406 1.86705C7.95715 1.70824 7.87839 1.56102 7.75304 1.4539C7.62768 1.34677 7.46466 1.28738 7.29556 1.28722H5.70512C5.53602 1.28738 5.373 1.34677 5.24765 1.4539C5.12229 1.56102 5.04353 1.70824 5.02662 1.86705C5.0007 2.07684 4.94249 2.28181 4.85256 2.47522ZM5.53993 12.2363V6.75047C5.53993 6.5796 5.46802 6.41574 5.34 6.29492C5.21199 6.17409 5.03837 6.10622 4.85734 6.10622C4.6763 6.10622 4.50268 6.17409 4.37467 6.29492C4.24666 6.41574 4.17474 6.5796 4.17474 6.75047V12.2388C4.17474 12.4097 4.24666 12.5736 4.37467 12.6944C4.50268 12.8152 4.6763 12.8831 4.85734 12.8831C5.03837 12.8831 5.21199 12.8152 5.34 12.6944C5.46802 12.5736 5.53993 12.4097 5.53993 12.2388V12.2363ZM8.82594 12.2363V6.75047C8.82594 6.5796 8.75402 6.41574 8.62601 6.29492C8.498 6.17409 8.32438 6.10622 8.14334 6.10622C7.96231 6.10622 7.78869 6.17409 7.66068 6.29492C7.53267 6.41574 7.46075 6.5796 7.46075 6.75047V12.2388C7.46075 12.4097 7.53267 12.5736 7.66068 12.6944C7.78869 12.8152 7.96231 12.8831 8.14334 12.8831C8.32438 12.8831 8.498 12.8152 8.62601 12.6944C8.75402 12.5736 8.82594 12.4097 8.82594 12.2388V12.2363Z"
      fill="#333333"
    />
  </svg>
);

const SettingIconSVG = () => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx={21} cy={21} r={21} fill="#262889" />
    <path
      d="M21 16.9474C18.7618 16.9474 16.9474 18.7618 16.9474 21C16.9474 23.2382 18.7618 25.0526 21 25.0526C23.2371 25.0499 25.0499 23.2371 25.0526 21C25.0526 18.7618 23.2382 16.9474 21 16.9474ZM21 23.8947C19.4013 23.8947 18.1053 22.5987 18.1053 21C18.1053 19.4013 19.4013 18.1053 21 18.1053C22.598 18.107 23.893 19.402 23.8947 21C23.8947 22.5987 22.5987 23.8947 21 23.8947ZM31.6042 18.7136L29.4196 17.9854C29.3939 17.9768 29.3687 17.9664 29.3445 17.9543C29.0585 17.8116 28.9422 17.4641 29.0849 17.178L30.115 15.1189C30.2262 14.896 30.1824 14.627 30.0065 14.4507L27.5505 11.9935C27.3739 11.818 27.1052 11.7743 26.8822 11.885L24.822 12.9151C24.7976 12.9272 24.7726 12.9376 24.7468 12.9462C24.4436 13.0474 24.1158 12.8836 24.0146 12.5804L23.2864 10.3958C23.2072 10.1595 22.986 10.0002 22.7368 10H19.2632C19.014 9.99986 18.7928 10.1594 18.7141 10.3958L17.9859 12.5804C17.9337 12.7402 17.8137 12.8688 17.658 12.9321C17.5033 12.9985 17.3271 12.9923 17.1775 12.9151L15.1184 11.885C14.8955 11.7737 14.6263 11.8174 14.4501 11.9935L11.9935 14.4507C11.8173 14.6268 11.7735 14.896 11.885 15.1189L12.9151 17.178C12.9275 17.2028 12.9381 17.2285 12.9469 17.2548C13.0474 17.5578 12.8834 17.8848 12.5804 17.9854L10.3958 18.7136C10.1595 18.7928 10.0002 19.014 10 19.2632V22.7368C10.0002 22.986 10.1595 23.2072 10.3958 23.2864L12.5798 24.0146C12.6058 24.0232 12.6313 24.0337 12.6558 24.046C12.9417 24.1887 13.0578 24.5361 12.9151 24.822L11.885 26.8811C11.7735 27.104 11.8173 27.3732 11.9935 27.5493L14.4502 30.0065C14.6266 30.1824 14.8955 30.2261 15.1184 30.115L17.1775 29.0849C17.3269 29.0066 17.5036 29.0004 17.6581 29.0679C17.8138 29.1312 17.9338 29.2598 17.986 29.4196L18.7142 31.6042C18.7928 31.8406 19.014 32.0001 19.2632 32H22.7368C22.986 31.9998 23.2072 31.8404 23.2864 31.6042L24.0146 29.4195C24.0232 29.3938 24.0336 29.3687 24.0457 29.3444C24.1884 29.0584 24.5359 28.9422 24.822 29.0848L26.8822 30.115C27.1053 30.2251 27.3737 30.1815 27.5505 30.0064L30.0065 27.5493C30.1824 27.373 30.2262 27.104 30.115 26.881L29.0849 24.8219C29.0094 24.6718 29.0032 24.4964 29.0679 24.3414C29.1312 24.1859 29.2599 24.0663 29.4196 24.0146L31.6042 23.2864C31.8405 23.2072 31.9998 22.986 32 22.7368V19.2632C31.9998 19.014 31.8405 18.7928 31.6042 18.7136ZM30.8421 22.3196L29.0532 22.9155C28.9754 22.9414 28.8996 22.9729 28.8262 23.0095C27.9681 23.4384 27.6202 24.4817 28.0491 25.3398L28.8927 27.0258L27.0269 28.8927L25.3398 28.0491C25.2658 28.012 25.1892 27.9803 25.1106 27.9542C24.2009 27.6515 23.2181 28.1436 22.9155 29.0532L22.3196 30.8421H19.6804L19.0839 29.0532C19.058 28.9757 19.0267 28.9002 18.9902 28.8271C18.5615 27.9686 17.518 27.6204 16.6595 28.0491L14.9736 28.8927L13.1073 27.0258L13.9509 25.3398C13.9873 25.2668 14.0186 25.1911 14.0445 25.1137C14.3482 24.2034 13.8565 23.2193 12.9462 22.9155L11.1579 22.3196V19.6804L12.9468 19.0846C13.0239 19.0588 13.0993 19.0275 13.1721 18.9912C14.0308 18.5626 14.3795 17.519 13.9509 16.6602L13.1073 14.9742L14.9737 13.1073L16.6596 13.9509C16.7327 13.9874 16.8082 14.0187 16.8857 14.0446C17.7959 14.3484 18.78 13.8569 19.0839 12.9468L19.6804 11.1579H22.3196L22.9156 12.9468C22.9417 13.0253 22.9735 13.1019 23.0106 13.176C23.4398 14.0333 24.4827 14.3801 25.3399 13.9509L27.0269 13.1073L28.8927 14.9743L28.0491 16.6602C28.012 16.7342 27.9803 16.8108 27.9542 16.8894C27.6515 17.7991 28.1436 18.7818 29.0532 19.0845L30.8421 19.6804V22.3196Z"
      fill="white"
    />
  </svg>
);
const EditVectorIconSVG = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.488 2.08721L13.9089 0.507701C13.2322 -0.169234 12.1281 -0.169234 11.4454 0.507701L1.70988 10.2461C1.64458 10.3114 1.59115 10.3945 1.56741 10.4836L0.0299079 15.2221C-0.0413275 15.4359 0.0180352 15.6675 0.172379 15.8278C0.285168 15.9406 0.439511 16 0.593854 16C0.653217 16 0.718517 15.9881 0.77788 15.9703L5.51504 14.4324C5.60408 14.4027 5.68719 14.3552 5.75249 14.2898L15.488 4.55149C16.1707 3.86862 16.1707 2.76415 15.488 2.08721ZM5.33695 13.0251L2.97431 10.6617L10.0504 3.5836L12.413 5.94693L5.33695 13.0251ZM2.39849 11.7662L4.22686 13.5951L1.51992 14.4739L2.39849 11.7662ZM14.651 3.70829L13.256 5.10373L10.8933 2.7404L12.2883 1.34496C12.502 1.13119 12.8582 1.13119 13.0719 1.34496L14.651 2.92448C14.8647 3.13824 14.8647 3.48859 14.651 3.70829Z"
      fill="black"
    />
  </svg>
);
const PlusVectorIconSVG = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C3.58564 0 0 3.58564 0 8C0 12.4144 3.58564 16 8 16C12.4144 16 16 12.4144 16 8C16 3.58564 12.4144 0 8 0Z"
      fill="#262889"
    />
    <path
      d="M11.3846 7.15486H8.74256V4.51281C8.74256 4.1764 8.46359 3.89743 8.12718 3.89743C7.79077 3.89743 7.5118 4.1764 7.5118 4.51281V7.15486H4.86974C4.53333 7.15486 4.25436 7.43384 4.25436 7.77025C4.25436 8.10666 4.53333 8.38563 4.86974 8.38563H7.5118V11.0277C7.5118 11.3641 7.79077 11.6431 8.12718 11.6431C8.46359 11.6431 8.74256 11.3641 8.74256 11.0277V8.38563H11.3846C11.721 8.38563 12 8.10666 12 7.77025C12 7.43384 11.721 7.15486 11.3846 7.15486Z"
      fill="white"
    />
  </svg>
);
const CloseFillVectorIconSVG = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6997 2.33416C10.5797 -0.778055 5.45987 -0.778055 2.33994 2.33416C-0.779981 5.44638 -0.779981 10.5536 2.33994 13.6658C5.45987 16.7781 10.4997 16.7781 13.6197 13.6658C16.7396 10.5536 16.8196 5.44638 13.6997 2.33416ZM10.2598 11.3516L8.01981 9.1172L5.77986 11.3516L4.65989 10.2344L6.89983 8L4.65989 5.76558L5.77986 4.64838L8.01981 6.88279L10.2598 4.64838L11.3797 5.76558L9.13978 8L11.3797 10.2344L10.2598 11.3516Z"
      fill="#262889"
    />
  </svg>
);

export const CloseFillVectorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CloseFillVectorIconSVG} {...props} />
);

export const PlusVectorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PlusVectorIconSVG} {...props} />
);

const DocumentVectorIconSVG = () => (
  <svg
    width={13}
    height={16}
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.65625 5.6H5.28125C5.5056 5.6 5.6875 5.4209 5.6875 5.2C5.6875 4.9791 5.5056 4.8 5.28125 4.8H3.65625C3.4319 4.8 3.25 4.9791 3.25 5.2C3.25 5.4209 3.4319 5.6 3.65625 5.6ZM12.9684 5.046C12.9478 4.99741 12.918 4.95361 12.8807 4.91694L8.00623 0.117432C7.96899 0.0807129 7.9245 0.0514161 7.87516 0.0311035C7.82602 0.0108886 7.773 0 7.71875 0H2.4375C1.0919 0.00146488 0.00148777 1.0751 0 2.4V13.6C0.00148777 14.9249 1.0919 15.9985 2.4375 16H10.5625C11.9081 15.9985 12.9985 14.9249 13 13.6V5.2C13 5.14658 12.9889 5.09438 12.9684 5.046ZM8.125 1.36558L11.6131 4.8H9.20807C8.6101 4.79951 8.1255 4.32236 8.125 3.73359V1.36558ZM12.1875 13.6C12.1864 14.4832 11.4595 15.1989 10.5625 15.2H2.4375C1.5405 15.1989 0.813641 14.4832 0.8125 13.6V2.4C0.813641 1.5168 1.5405 0.801123 2.4375 0.8H7.3125V3.73359C7.31384 4.76382 8.16175 5.59868 9.20807 5.6H12.1875V13.6ZM3.25 8.4C3.25 8.6209 3.4319 8.8 3.65625 8.8H9.34375C9.5681 8.8 9.75 8.6209 9.75 8.4C9.75 8.1791 9.5681 8 9.34375 8H3.65625C3.4319 8 3.25 8.1791 3.25 8.4ZM9.34375 11.2H3.65625C3.4319 11.2 3.25 11.3791 3.25 11.6C3.25 11.8209 3.4319 12 3.65625 12H9.34375C9.5681 12 9.75 11.8209 9.75 11.6C9.75 11.3791 9.5681 11.2 9.34375 11.2Z"
      fill="white"
    />
  </svg>
);

export const DocumentIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DocumentVectorIconSVG} {...props} />
);

export const AgreementIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AgreementSVG} {...props} />
);

export const LinkIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LinkSVG} {...props} />
);

const RfScannerVectorIconSVG = ({ color = '#268959' }) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9618 1.00098H5.84687C4.65393 1.00009 3.50262 1.43951 2.61363 2.23501C1.72464 3.0305 1.16051 4.12611 1.02937 5.31182C0.898224 6.49754 1.2093 7.68994 1.90296 8.66048C2.59663 9.63102 3.62408 10.3114 4.78839 10.5712L1.03723 20.7531C1.0173 20.8103 1.00671 20.8704 1.00588 20.931C1.00588 20.9378 1.00189 20.9435 1.00189 20.9503V23.2303C1.00189 23.3815 1.06194 23.5265 1.16884 23.6334C1.27573 23.7403 1.42071 23.8003 1.57189 23.8003H8.98186C9.13304 23.8003 9.27802 23.7403 9.38491 23.6334C9.49181 23.5265 9.55186 23.3815 9.55186 23.2303V18.0741L10.9905 14.1109H12.9719C13.123 14.1109 13.268 14.0509 13.3749 13.944C13.4818 13.8371 13.5418 13.6921 13.5418 13.5409V10.6909H16.9618C17.113 10.6909 17.258 10.6309 17.3649 10.524C17.4718 10.4171 17.5318 10.2721 17.5318 10.1209V1.57098C17.5318 1.4198 17.4718 1.27482 17.3649 1.16793C17.258 1.06103 17.113 1.00098 16.9618 1.00098ZM5.95916 10.6909H11.0185L10.0666 13.3158L10.0626 13.3255L7.87037 19.3663C7.72716 19.6876 7.48879 19.9571 7.18747 20.1386C6.88614 20.32 6.53639 20.4046 6.18545 20.3809H2.38926L5.95916 10.6909ZM2.14188 22.6609V21.5209H6.18545C6.59913 21.5251 7.00942 21.4459 7.3919 21.2883C7.77439 21.1306 8.12126 20.8977 8.41187 20.6032V22.6609H2.14188ZM12.4019 12.9709H11.4044L12.2309 10.6909H12.4019V12.9709ZM16.3918 9.55095H5.84687C4.86425 9.55095 3.92187 9.16061 3.22705 8.46579C2.53223 7.77097 2.14188 6.82859 2.14188 5.84596C2.14188 4.86334 2.53223 3.92096 3.22705 3.22614C3.92187 2.53132 4.86425 2.14097 5.84687 2.14097H16.3918V9.55095ZM19.5696 3.24221C19.5084 3.19775 19.439 3.16591 19.3654 3.14853C19.2918 3.13116 19.2155 3.1286 19.1409 3.141C19.0664 3.1534 18.995 3.18052 18.931 3.22078C18.867 3.26104 18.8116 3.31363 18.7681 3.37549C18.7246 3.43735 18.6939 3.50724 18.6777 3.58109C18.6615 3.65495 18.6601 3.73129 18.6737 3.80568C18.6873 3.88006 18.7156 3.95099 18.7568 4.01435C18.7981 4.07771 18.8515 4.13223 18.9141 4.17473C19.1806 4.36701 19.4 4.61739 19.5555 4.90692C19.711 5.19646 19.7987 5.51756 19.8118 5.84596C19.8014 6.17493 19.7149 6.497 19.5591 6.78695C19.4034 7.07689 19.1826 7.32684 18.9141 7.5172C18.8515 7.55969 18.7981 7.61421 18.7568 7.67757C18.7156 7.74093 18.6873 7.81187 18.6737 7.88625C18.6601 7.96063 18.6615 8.03698 18.6777 8.11083C18.6939 8.18469 18.7246 8.25458 18.7681 8.31644C18.8116 8.3783 18.867 8.43089 18.931 8.47115C18.995 8.5114 19.0664 8.53852 19.1409 8.55093C19.2155 8.56333 19.2918 8.56077 19.3654 8.54339C19.439 8.52602 19.5084 8.49417 19.5696 8.44972C19.9882 8.15465 20.3314 7.76519 20.5715 7.31285C20.8117 6.86051 20.9419 6.358 20.9518 5.84596C20.9393 5.33446 20.8079 4.83289 20.568 4.38096C20.3281 3.92903 19.9863 3.53916 19.5696 3.24221Z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
    <path
      d="M21.1331 1.15314C21.0782 1.20417 21.034 1.26551 21.0029 1.33364C20.9718 1.40178 20.9544 1.47537 20.9518 1.55022C20.9491 1.62508 20.9613 1.69972 20.9875 1.76988C21.0137 1.84004 21.0535 1.90434 21.1046 1.95912C22.0877 3.01657 22.6427 4.40165 22.6618 5.84537C22.6427 7.28908 22.0877 8.67417 21.1046 9.73162C21.0535 9.78641 21.0137 9.85072 20.9876 9.92088C20.9614 9.99103 20.9492 10.0657 20.9519 10.1405C20.9545 10.2153 20.9719 10.2889 21.003 10.3571C21.0341 10.4252 21.0783 10.4865 21.1331 10.5376C21.1879 10.5886 21.2522 10.6284 21.3223 10.6546C21.3925 10.6808 21.4671 10.6929 21.5419 10.6903C21.6168 10.6876 21.6904 10.6703 21.7585 10.6392C21.8266 10.6081 21.888 10.5639 21.939 10.5091C23.1172 9.23954 23.7811 7.57724 23.8018 5.84537C23.7811 4.1135 23.1172 2.45119 21.939 1.18164C21.888 1.12682 21.8267 1.08259 21.7585 1.05148C21.6904 1.02038 21.6168 1.003 21.542 1.00036C21.4671 0.997709 21.3925 1.00984 21.3223 1.03606C21.2521 1.06227 21.1878 1.10206 21.1331 1.15314Z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>

);

export const RfScannerIcon: React.FC<IconProps> = (props) => (
  <Icon component={() => <RfScannerVectorIconSVG {...props} />} />
);
const MessageVectorIconSVG = () => (
  <svg
    width={20}
    height={18}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7619 1C4.92381 1 1 4.58095 1 9C1.00739 10.0432 1.22896 11.0739 1.65097 12.028C2.07298 12.9821 2.68644 13.8394 3.45333 14.5467L1 17H9.7619C14.6 17 18.5238 13.419 18.5238 9C18.5238 4.58095 14.6 1 9.7619 1Z"
      fill="white"
      stroke="black"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.88 10.3791C10.366 10.3791 10.76 9.98515 10.76 9.49914C10.76 9.01313 10.366 8.61914 9.88 8.61914C9.39399 8.61914 9 9.01313 9 9.49914C9 9.98515 9.39399 10.3791 9.88 10.3791Z"
      fill="black"
    />
    <path
      d="M5.45129 10.3791C5.9373 10.3791 6.33129 9.98515 6.33129 9.49914C6.33129 9.01313 5.9373 8.61914 5.45129 8.61914C4.96528 8.61914 4.57129 9.01313 4.57129 9.49914C4.57129 9.98515 4.96528 10.3791 5.45129 10.3791Z"
      fill="black"
    />
    <path
      d="M13.88 10.3791C14.366 10.3791 14.76 9.98515 14.76 9.49914C14.76 9.01313 14.366 8.61914 13.88 8.61914C13.394 8.61914 13 9.01313 13 9.49914C13 9.98515 13.394 10.3791 13.88 10.3791Z"
      fill="black"
    />
  </svg>
);

export const MessageIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MessageVectorIconSVG} {...props} />
);

export const OrderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={OrdersSVG} {...props} />
);

export const DashboardIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DashboardSVG} {...props} />
);

export const StatusIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={StatusSVG} {...props} />
);

export const DropboxIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DropboxSVG} {...props} />
);

export const ProfessionalIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProfessionalSVG} {...props} />
);

export const EditIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EditIconSVG} {...props} />
);

export const SearchIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SearchIconSVG} {...props} />
);
export const ArrowDownIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowDownIconSVG} {...props} />
);
export const ArrowRightIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowRightIconSVG} {...props} />
);
export const ArrowLeftIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowLeftIconSVG} {...props} />
);
export const CloseIcon = (props: { fill?: string }) => (
  <Icon component={() => <CloseIconSVG {...props} />} />
);
export const SaveIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SaveIconSVG} {...props} />
);
export const DeleteIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DeleteIconSVG} {...props} />
);
export const SettingIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SettingIconSVG} {...props} />
);
export const EditVectorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EditVectorIconSVG} {...props} />
);
